import { useEffect, useState } from 'react'

import ArrowIcon from '../ArrowIcon'

export default function MessageForm() {
  const [sending, setSending] = useState(false)
  useEffect(() => {
    const reset = () => setSending(false)
    window.addEventListener('pageshow', reset)
    return () => window.removeEventListener('pageshow', reset)
  }, [])
  const submit = event => {
    if (sending || !event.currentTarget.reportValidity()) { event.preventDefault(); return }
    setSending(true)
  }
  return <form action="https://formsubmit.co/oabdelrazek29@gmail.com" method="POST" onSubmit={submit}>
    <input type="hidden" name="_subject" value="New message from Omar's portfolio" />
    <input type="hidden" name="_captcha" value="true" />
    <input type="hidden" name="_template" value="table" />
    <input className="contact-spam-trap" type="text" name="_honey" tabIndex={-1} autoComplete="off" aria-hidden="true" />
    <ul>
      <li className="half"><input type="text" name="name" placeholder="Name" aria-label="Name" autoComplete="name" required maxLength={100} pattern=".*\S.*" /></li>
      <li className="half"><input type="email" name="email" placeholder="Email" aria-label="Email" autoComplete="email" required maxLength={254} /></li>
      <li><input type="text" name="subject" placeholder="Subject" aria-label="Subject" required maxLength={160} pattern=".*\S.*" /></li>
      <li><textarea name="message" placeholder="What would you like to talk about?" aria-label="Message" required minLength={10} maxLength={5000} /></li>
      <li><button className="flat-button" type="submit" disabled={sending}>{sending ? 'CONTINUING…' : 'SEND MESSAGE'}</button></li>
    </ul>
    <p className="delivery-note" role="status">{sending ? 'Opening message verification. If it does not open, go back and try again.' : 'Delivered via FormSubmit with CAPTCHA verification. Your name, email, and message are shared with the delivery service.'}</p>
    <a className="contact-email-fallback" href="mailto:oabdelrazek@gmail.com">Or email me directly <ArrowIcon /></a>
  </form>
}
